import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with your publishable key
// TODO: Replace with your actual Stripe publishable key
// Get it from: https://dashboard.stripe.com/apikeys
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_YOUR_KEY_HERE');

export default stripePromise;
